<div class="main-shell min-h-screen">
  <div class="flex min-h-screen">
    <div class="w-full max-w-[245px] border-r border-neutral-100">
      <app-sidebar #sideBar [NavItems]="sidebarItems" [activeItem]="activeItem" [activeId]="activeId"></app-sidebar>
    </div>
    <div class="grow overflow-y-auto">
      @if (shellComponents.header !== false) {
        <app-header></app-header>
      }
      <div class="vertical-scroll">

        @if (tabTitle) {
          <div class="justify-between p-4 hidden">
            <h3 class="font-semibold text-2xl">{{tabTitle}}</h3>
            @if (shellComponents.breadcrumbs !== false) {
              <app-common-breadcrumbs [enableBackBtn]="false" class="p-0"></app-common-breadcrumbs>
            }
          </div>
        }
        @if (shellComponents.tab !== false && tabItems.length) {
          <app-common-tab-menu [items]="tabItems"></app-common-tab-menu>
        }
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
